const MESSAGE = 'CLIENT_MESSAGE';

const actions = {
  SEND_CLIENT_MESSAGE: MESSAGE + '_SEND',
  SEND_CLIENT_MESSAGE_SUCCESS: MESSAGE + '_SEND_SUCCESS',
  SEND_CLIENT_MESSAGE_ERROR: MESSAGE + '_SEND_ERROR',

  LOAD_CLIENT_MESSAGES: MESSAGE + '_LOAD',
  LOAD_CLIENT_MESSAGES_SUCCESS: MESSAGE + '_LOAD_SUCCESS',
  LOAD_CLIENT_MESSAGES_ERROR: MESSAGE + '_LOAD_ERROR',

  LOAD_ALL_CLIENT_MESSAGES: MESSAGE + '_LOAD_ALL',
  LOAD_ALL_CLIENT_MESSAGES_SUCCESS: MESSAGE + '_LOAD_ALL_SUCCESS',
  LOAD_ALL_CLIENT_MESSAGES_ERROR: MESSAGE + '_LOAD_ALL_ERROR',

  SEND_CLIENT_REPLY: MESSAGE + '_REPLY',
  SEND_CLIENT_REPLY_SUCCESS: MESSAGE + '_REPLY_SUCCESS',
  SEND_CLIENT_REPLY_ERROR: MESSAGE + '_REPLY_ERROR',

  sendClientMessage: (payload: {
    clientId: string;
    area: string;
    invoiceNumber?: string;
    subject?: string;
    message: string;
  }) => ({
    type: actions.SEND_CLIENT_MESSAGE,
    payload,
  }),

  sendClientMessageSuccess: () => ({
    type: actions.SEND_CLIENT_MESSAGE_SUCCESS,
  }),

  sendClientMessageError: (error: string) => ({
    type: actions.SEND_CLIENT_MESSAGE_ERROR,
    payload: { error },
  }),

  loadClientMessages: (clientId: string) => ({
    type: actions.LOAD_CLIENT_MESSAGES,
    payload: { clientId },
  }),

  loadClientMessagesSuccess: (messages: any[]) => ({
    type: actions.LOAD_CLIENT_MESSAGES_SUCCESS,
    payload: { messages },
  }),

  loadClientMessagesError: (error: string) => ({
    type: actions.LOAD_CLIENT_MESSAGES_ERROR,
    payload: { error },
  }),

  loadAllClientMessages: () => ({
    type: actions.LOAD_ALL_CLIENT_MESSAGES,
  }),

  loadAllClientMessagesSuccess: (messages: any[]) => ({
    type: actions.LOAD_ALL_CLIENT_MESSAGES_SUCCESS,
    payload: { messages },
  }),

  loadAllClientMessagesError: (error: string) => ({
    type: actions.LOAD_ALL_CLIENT_MESSAGES_ERROR,
    payload: { error },
  }),

  sendClientReply: (payload: {
    to: string;
    subject?: string;
    message: string;
    clientId?: string;
    clientName?: string;
  }) => ({
    type: actions.SEND_CLIENT_REPLY,
    payload,
  }),

  sendClientReplySuccess: () => ({
    type: actions.SEND_CLIENT_REPLY_SUCCESS,
  }),

  sendClientReplyError: (error: string) => ({
    type: actions.SEND_CLIENT_REPLY_ERROR,
    payload: { error },
  }),
};

export default actions;
